import './BetbookOptionsButton.less';
import clsx from 'clsx';
import React, {
    ButtonHTMLAttributes,
    forwardRef,
    MouseEventHandler,
    ReactNode,
    useEffect,
    useRef,
    useState
} from 'react';
import BetbookOptionsButtonIcon from '../../icons/svg/betbook-options-button-icon-sv.svg';

export interface BetbookOptionsProps {
    content: ReactNode;
    className?: string;
}

export default function BetbookOptionsButtonPortal({ content, className }: BetbookOptionsProps) {
    const [showForumPopup, setShowForumPopup] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        function handleClickOutside(e) {
            if (!ref.current.contains(e.target)) {
                setShowForumPopup(false);
            }
        }
        if (content) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
    }, [content]);

    function toggle(e) {
        e.preventDefault();
        setShowForumPopup(!showForumPopup);
    }

    return (
        <BetbookOptionsButton className={className} onClick={toggle} ref={ref}>
            <BetbookOptionsButtonIcon />
            {showForumPopup ? <div className="forum-box br-radius-xxxs">{content}</div> : null}
        </BetbookOptionsButton>
    );
}

export const BetbookOptionsButtonMobile = ({ onClick }: { onClick?: MouseEventHandler<HTMLButtonElement> }) => (
    <BetbookOptionsButton onClick={onClick}>
        <BetbookOptionsButtonIcon />
    </BetbookOptionsButton>
);

export const BetbookOptionsButton = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
    ({ onClick, className, children, ...other }, ref) => (
        <button
            className={clsx('betbook-option-button', className)}
            onClick={onClick}
            ref={ref}
            data-atid="betbook-option-button"
            {...other}
        >
            {children}
        </button>
    )
);
